import type { ForcedMovementSourcePriorityInput } from '../types';

/** Match the collector's normalized source-kind ladder; subtype resolution is supplied by the caller. */
export function forcedMovementSourcePriority(input: ForcedMovementSourcePriorityInput): number {
    switch (input.sourceKind) {
        case 'status_effect': return 0;
        case 'equipment': return 1;
        case 'feat':
        case 'passive_ability':
        case 'ability':
        case 'full_ability':
        case 'free_ability':
        case 'quick_ability': return 2;
        case 'class':
        case 'subclass':
        case 'background':
        case 'ancestry': return 3;
        case 'creature_type':
        case 'creature_template':
        case 'carrier': return 4;
        default: return input.isCreatureSubtype ? 4 : 5;
    }
}

/** PHP spaceship result: equal priority deliberately has no secondary identity/name ordering. */
export function compareForcedMovementSources(
    left: ForcedMovementSourcePriorityInput,
    right: ForcedMovementSourcePriorityInput,
): number {
    return Math.sign(forcedMovementSourcePriority(left) - forcedMovementSourcePriority(right));
}

/** Return a new order without mutating the caller's metadata or sorting equal priorities by name. */
export function orderForcedMovementSources<T extends ForcedMovementSourcePriorityInput>(sources: readonly T[]): T[] {
    return sources.map((source, index) => ({ source, index }))
        .sort((left, right) => compareForcedMovementSources(left.source, right.source) || left.index - right.index)
        .map(({ source }) => source);
}
